{
  "error-message-wrapper": {
    "text": {
      "custom": "{{ message }}",
      "email": "Invalid email",
      "format": "Incorrect format ({{ correctFormat }})",
      "inRange": "{{ nameOfThisControl }} must be from {{ min }} to {{ max }}",
      "notEarlier": "{{ nameOfThisControl }} must be later than {{ nameOfAnotherControl }}",
      "min": "Input value cannot be less than {{ min }}",
      "max": "Input value cannot be greater than {{ max }}",
      "minlength": "Input value must have at least {{ requiredLength }} characters",
      "maxlength": "Input value must have at most {{ requiredLength }} characters",
      "maxNumberSms": "The maximum number of {{ max }} SMS has been exceeded",
      "mustContainContent": "{{ nameOfInput }} must contain {{ mustContainContent }}",
      "required": "This information is required",
      "sameValue": "{{ nameOfThisControl }} and {{ nameOfAnotherControl }} must be same"
    }
  }
}
